// ref: https://developers.google.com/youtube/iframe_api_reference?hl=ja

declare global {
  interface Window {
    onYouTubeIframeAPIReady: () => void;
  }
}

export default class YouTubePlayer {
  constructor(
    public domId: string,
    public videoId: string,
    public onPlay: () => void,
    public onEnd: () => void,
  ) {}

  public begin(): void {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode!.insertBefore(tag, firstScriptTag);

    const onYouTubeIframeAPIReady = () => {
      new YT.Player(this.domId, {
        height: '100%',
        width: '100%',
        videoId: this.videoId,
        events: {
          onStateChange: onPlayerStateChange,
        },
      });
    };

    let played = false;
    let ended = false;
    const onPlayerStateChange = (event: YT.OnStateChangeEvent) => {
      if (event.data === YT.PlayerState.PLAYING && !played) {
        this.onPlay();
        played = true;
      }
      if (event.data === YT.PlayerState.ENDED && !ended) {
        this.onEnd();
        ended = true;
      }
    };

    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
  }
}
